import { Box, Tabs, Tab } from "@mui/material";
import { windowSelectorStyles } from "./style";
import { useMemo } from "react";

const windowOptions = [
  { label: "Plan", value: "plan", extras: true },
  { label: "Day", value: "day" },
  { label: "Week", value: "week" },
  { label: "Month", value: "month" },
  { label: "Year", value: "year" },
];

const WindowSelector = ({ value, onChange, extras = [] }) => {
  const stableExtras = useMemo(() => extras ?? [], [extras]);

  const options = useMemo(() => {
    return windowOptions.filter(
      (it) => !it.extras || stableExtras.includes(it.value)
    );
  }, [stableExtras]);

  const handleChange = (e, newValue) => {
    onChange(newValue);
  };

  return (
    <Box className="window-selector" mb={1}>
      <Tabs
        value={value}
        onChange={handleChange}
        sx={(theme) => windowSelectorStyles(theme)}
      >
        {options?.map((option, i) => (
          <Tab key={i} label={option?.label} value={option?.value} />
        ))}
      </Tabs>
    </Box>
  );
};

export default WindowSelector;
